<p-dialog
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '95%', 'max-width': '700px', 'max-height': 'calc(100vh - 10rem)' }"
  (onHide)="closeDialog()"
>
  <div class="flex column gap-05 padding-05">
    <div class="flex flex-between width-100 align-center">
      <div class="label">HI1</div>
      @if (hi1Record$ | async; as hi1Record) {
      <app-save-icon [isSaving]="hi1Record.isLoading" [isSaved]="isSaved(hi1Record)" [error]="hasError(hi1Record)" />
      }
    </div>
    <div class="flex flex-between width-100 align-center">
      <div class="label">HI2</div>
      @if (hi2Record$ | async; as hi2Record) {
      <app-save-icon [isSaving]="hi2Record.isLoading" [isSaved]="isSaved(hi2Record)" [error]="hasError(hi2Record)" />
      }
    </div>
    <div class="flex flex-between width-100 align-center">
      <div class="label">Active Plan</div>
      @if (activePlan$ | async; as activePlan) {
      <app-save-icon [isSaving]="activePlan.isLoading" [isSaved]="isSaved(activePlan)" [error]="hasError(activePlan)" />
      }
    </div>
    <div class="flex flex-between width-100 align-center">
      <div class="label">Standby Plan</div>
      @if (standbyPlan$ | async; as standbyPlan) {
      <app-save-icon
        [isSaving]="standbyPlan.isLoading"
        [isSaved]="isSaved(standbyPlan)"
        [error]="hasError(standbyPlan)"
      />
      }
    </div>
    <div class="flex flex-between width-100 align-center">
      <div class="label">History</div>
      @if (history$ | async; as history) {
      <app-save-icon [isSaving]="history.isLoading" [isSaved]="isSaved(history)" [error]="hasError(history)" />
      }
    </div>
    <div class="flex flex-between width-100 align-center">
      <div class="label">Pilot Details</div>
      @if (pilotData$ | async; as pilotData) {
      <app-save-icon [isSaving]="pilotData.isLoading" [isSaved]="isSaved(pilotData)" [error]="hasError(pilotData)" />
      }
    </div>
    <div class="flex flex-between width-100 align-center">
      <div class="label">Settings</div>
      @if (settings$ | async; as settings) {
      <app-save-icon [isSaving]="settings.isLoading" [isSaved]="isSaved(settings)" [error]="hasError(settings)" />
      }
    </div>
    <p-divider />
    <div class="flex width-100">
      <i
        class="pi pi-times-circle flex align-center flex-center"
        style="color: var(--nt-yellow); width: 1.5rem; height: auto; font-weight: bold; margin-right: 5px; font-size: 1.3rem;"
      ></i>
      <div class="text">Indicates not available or failed to load.</div>
    </div>
    <div class="text">Saved data will be available offline.</div>
    <div class="text">
      <span style="font-style: italic">Note:</span> Closing this dialog while an item is still loading will cancel that
      download.
    </div>
  </div>
</p-dialog>
